import {DataTransferObject} from './DataTransferObject';
import {Order} from '../Models';
import {CustomerDataDTO} from './CustomerDataDTO';
import {PaymentInfoDTO} from './PaymentInfoDTO';
import {CreditCardDTO} from './CreditCardDTO';
import {ShopUrlsDTO} from './ShopUrlsDTO';
import {AdditionalOrderItemConfigurationDTO} from './AdditionalOrderItemConfigurationDTO';

export class CheckoutDataDTO extends DataTransferObject {
  orderId: number | string = 0;
  buyerData: CustomerDataDTO = new CustomerDataDTO();
  invoiceData: CustomerDataDTO = new CustomerDataDTO();
  paymentInfo: PaymentInfoDTO | null = new CreditCardDTO();
  shopUrls: ShopUrlsDTO = new ShopUrlsDTO();
  additionalOrderItemConfigurations: Array<AdditionalOrderItemConfigurationDTO> = [];
  token: string | null = null;

  fromModel(order: Order): CheckoutDataDTO {
    const checkoutDataDTO = new CheckoutDataDTO();
    checkoutDataDTO.orderId = order.id;
    checkoutDataDTO.buyerData = order.buyerData ? (new CustomerDataDTO()).fromData(order.buyerData) : new CustomerDataDTO();
    checkoutDataDTO.invoiceData = order.invoiceData ? (new CustomerDataDTO()).fromData(order.invoiceData) : new CustomerDataDTO();
    checkoutDataDTO.shopUrls = order.shopUrls ? (new ShopUrlsDTO()).fromData(order.shopUrls) : new ShopUrlsDTO();
    checkoutDataDTO.paymentInfo = new CreditCardDTO();
    order.additionalOrderItemConfigurations.forEach((orderItemConfig) => {
      const orderItemConfigDTO = new AdditionalOrderItemConfigurationDTO();
      checkoutDataDTO.additionalOrderItemConfigurations.push(orderItemConfigDTO.fromModel(orderItemConfig));
    });
    checkoutDataDTO.token = order.token;
    return checkoutDataDTO;
  }
}
